import { createFileRoute } from "@tanstack/react-router";
import { CityHub } from "./kopa-och-salja.index";

const TITLE = "Buying and selling second hand in your town | Sellavo";
const DESCRIPTION =
  "Find out how to buy and sell second hand where you live, with local tips on pickup, shipping and what sells best.";

export const Route = createFileRoute("/en/buy-and-sell")({
  loader: async () => {
    const { CITIES } = await import("@/lib/orter-seo");
    return { cities: CITIES.map((c) => ({ slug: c.slug, name: c.name })) };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/buy-and-sell" }],
  }),
  component: CityHub,
});
